<template>
  <div class="cjSearch">
    <Header title="班级成绩查询"></Header>
    <div class="more">
      <van-field
        v-model="xnxq.mc"
        label="学年学期"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="onShow('学年学期', 'xnxq')"
        readonly
        required
      />
      <van-field
        v-model="yx.mc"
        label="院系"
        right-icon="arrow"
        input-align="right"
        placeholder="无院系数据"
        @click="onShow('院系', 'yx')"
        readonly
        required
      />
      <van-field
        v-model="nj.mc"
        label="年级"
        right-icon="arrow"
        input-align="right"
        placeholder="无年级数据"
        @click="onShow('年级', 'nj')"
        required
        readonly
      />
      <van-field
        v-model="zy.mc"
        label="专业"
        right-icon="arrow"
        input-align="right"
        placeholder="无专业数据"
        @click="onShow('专业', 'zy')"
        required
        readonly
      />
      <van-field
        v-model="bj.mc"
        label="班级"
        right-icon="arrow"
        input-align="right"
        placeholder="无班级数据"
        @click="onShow('班级', 'bj')"
        required
        readonly
      />
      <van-field
        v-model="xm"
        label="姓名"
        input-align="right"
        placeholder="非必填"
      />
      <van-field
        v-model="kcmc"
        label="课程名称"
        input-align="right"
        placeholder="非必填"
      />
    </div>
    <div class="bottom-btn">
      <button @click="search">查询</button>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../../../utils/axios";
export default {
  data() {
    return {
      xnxq: {},
      yx: {},
      zy: {},
      nj: {},
      bj: {},
      xm: "",
      kcmc: "",
      show: false,
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: []
      }
    };
  },
  methods: {
    // 弹出选择器
    onShow(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].dm = value[0].value;
      this[value1].mc = value[0].text;
      switch (value1) {
        case "yx":
          this.getZy();
          break;
        case "nj":
          this.getZy();
          break;
        case "zy":
          this.getBj();
          break;
      }
    },
    // 获取学年学期
    async getXnxq() {
      let xnxqDefaultIndex = 0;
      const res = await Api.getSemesterList();

      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (item.isdqxq === "1") {
              this.xnxqDefaultIndex = index;
              this.xnxq = {
                dm: item.semesterId,
                mc: item.semesterName
              };
            }
            return {
              value: item.semesterId,
              text: item.semesterName
            };
          }),
          defaultIndex: this.xnxqDefaultIndex
        }
      ];
    },
    // 获取上课院系
    async getSkyx() {
      const res = await Api.getAcademyList();

      this.columns.yx = [
        {
          values: res.data.map((item, index) => {
            if (index === 0) {
              this.yx = {
                dm: item.academyId,
                mc: item.academyName
              };
            }
            return {
              value: item.academyId,
              text: item.academyName
            };
          })
        }
      ];
      this.getNj();
    },
    // 获取年级
    async getNj() {
      const res = await Api.getGradeList();

      this.columns.nj = [
        {
          values: res.data.map((item, index) => {
            if (index === 0) {
              this.nj = {
                dm: item.gradeId,
                mc: item.gradeName
              };
            }
            return {
              value: item.gradeId,
              text: item.gradeName
            };
          })
        }
      ];

      this.getZy();
    },
    // 获取专业
    async getZy() {
      const res = await Api.getAnnualMajorList({
        academyId: this.yx.dm,
        grade: this.nj.dm
      });
      this.columns.zy = [
        {
          values: res.data.map((item, index) => {
            if (index === 0) {
              this.zy = {
                dm: item.annumajorId,
                mc: item.annumajorName
              };
            }
            return {
              value: item.annumajorId,
              text: item.annumajorName
            };
          })
        }
      ];
      if (res.data.length > 0) {
        this.getBj();
      }
    },
    // 获取班级
    async getBj() {
      const res = await Api.getClassList({
        academyId: this.yx.dm,
        majorId: this.zy.dm,
        gradeId: this.nj.dm
      });

      this.columns.bj = [
        {
          values: res.data.map((item, index) => {
            if (index === 0) {
              this.bj = {
                dm: item.calssId,
                mc: item.className
              };
            }
            return {
              value: item.calssId,
              text: item.className
            };
          })
        }
      ];
    },
    search() {
      if (
        JSON.stringify(this.xnxq) == "{}" ||
        JSON.stringify(this.yx) == "{}" ||
        JSON.stringify(this.zy) == "{}" ||
        JSON.stringify(this.nj) == "{}" ||
        JSON.stringify(this.bj) == "{}"
      ) {
        this.$toast.fail("请填写完整条件！");
        return;
      }
      this.$router.push({
        path: "/grade/search/grade",
        query: {
          xnxq: this.xnxq,
          yx: this.yx,
          zy: this.zy,
          nj: this.nj,
          bj: this.bj,
          xm: this.xm,
          kcmc: this.kcmc
        }
      });
    }
  },
  created() {
    this.getXnxq();
    this.getSkyx();
  }
};
</script>
<style lang="less" scoped>
.cjSearch {
  .more {
    padding-bottom: 60px;
  }
  .bottom-btn {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding: 0 5% 10px 5%;
    background: #fff;
    display: flex;
    justify-content: space-between;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
    // button:first-child {
    //   width: 47.5%;
    //   height: 44px;
    //   background: #ecedfd;
    //   border-radius: 3px;
    //   color: #7469f8;
    // }
    // button:last-child {
    //   width: 47.5%;
    //   height: 44px;
    //   background: #7469f8;
    //   border-radius: 3px;
    //   color: #fff;
    // }
  }
}
</style>
<style lang="less">
.cjSearch {
  .more {
    .van-cell__title,
    .van-cell.van-field .van-cell__title.van-field__label > span {
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/grade/search/search.vue